// extracted by mini-css-extract-plugin
export default {"spinner":"spinner__f-1tg"};